import type { TranslationChallengeBlock, SourceLanguageCode } from '@ellie/shared';
import { BlockHeader } from '../BlockHeader';
import { NativeHint } from '../NativeHint';

interface Props {
  block: TranslationChallengeBlock;
  index: number;
  nativeLanguage: SourceLanguageCode;
  targetLanguage: string;
  pageNumber: number;
}

function DifficultyBadge({ difficulty }: { difficulty: string }) {
  return <span className={`wb-translation-difficulty wb-${difficulty}`}>{difficulty}</span>;
}

export function TranslationChallengePreview({
  block,
  index,
  nativeLanguage,
  targetLanguage,
  pageNumber,
}: Props) {
  return (
    <div className="wb-page">
      <BlockHeader block={block} index={index} />

      <div className="wb-block-instructions">
        <span className="wb-icon">{'\u{1F504}'}</span>
        <div>
          <p>{block.instructions}</p>
          <NativeHint
            text={block.instructionsNative}
            nativeLanguage={nativeLanguage}
            label={targetLanguage.toUpperCase()}
          />
        </div>
      </div>

      {/* To target language section */}
      {block.toTarget.length > 0 && (
        <div className="wb-translation-section">
          <div className="wb-translation-section-header">Translate to target language</div>
          {block.toTarget.map((item, i) => (
            <div key={i} className="wb-translation-item">
              <p className="wb-translation-source">
                <span className="wb-fill-number">{i + 1}</span>
                {item.source}
                <DifficultyBadge difficulty={item.difficulty} />
              </p>
              <div className="wb-write-area" style={{ minHeight: '2rem' }} />
            </div>
          ))}
        </div>
      )}

      {/* To native language section */}
      {block.toNative.length > 0 && (
        <div className="wb-translation-section">
          <div className="wb-translation-section-header">Translate to native language</div>
          {block.toNative.map((item, i) => (
            <div key={i} className="wb-translation-item">
              <p className="wb-translation-source">
                <span className="wb-fill-number">{i + 1}</span>
                {item.source}
                <DifficultyBadge difficulty={item.difficulty} />
              </p>
              <div className="wb-write-area" style={{ minHeight: '2rem' }} />
            </div>
          ))}
        </div>
      )}

      <span className="wb-page-number">{pageNumber}</span>
    </div>
  );
}
